import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InvitationLogEntryType } from '@api/models/enums/InvitationLogEntryType';
import { QcsAutocompleteWithoutFormik } from '../../../common/form/QcsAutocompleteWithoutFormik';

interface Props {
  value?: InvitationLogEntryType[];
  onChange: (value?: InvitationLogEntryType[]) => void;
}

export const GridFilterLogType: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options = useMemo(() => Object.values(InvitationLogEntryType), []);

  const handleChange = (val?: InvitationLogEntryType | InvitationLogEntryType[] | null) => {
    onChange((val as InvitationLogEntryType[]) ?? []);
  };

  return (
    <QcsAutocompleteWithoutFormik
      multiple
      options={options}
      loading={false}
      loadingError={false}
      value={value ?? []}
      getOptionId={(option: InvitationLogEntryType) => option}
      getOptionName={(option: InvitationLogEntryType) =>
        t(`invitation.log.filterTypes.${option}`)
      }
      onChange={handleChange}
    />
  );
};
